// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './utils/store';
import router from './utils/router';
// import VueYoutube from 'vue-youtube';
import MyDate from "@/utils/Date.js";
import * as VueGoogleMaps from "vue2-google-maps";
import { VueHammer } from 'vue2-hammer';
import VuePluralize from 'vue-pluralize';
import Message from 'vue-message/src/lib';

Vue.use(VuePluralize);
Vue.use(require('vue-scrollto'));
// Vue.use(VueYoutube);
Vue.use(MyDate); // JS Date Prototype extension; Date Formatting
Vue.use(Message);
/**
 * GoogleMaps Api
 */
Vue.use(VueGoogleMaps, {
	load: {
		// key: "AIzaSyBssDdPOxZmkhKUfS73WvUPOGcbOQIM4p8", // ToDo: kassecker API key
		key : 'AIzaSyAWT7VfHXsuMZ3epcG0HmqAot472xlpAuA',
		libraries: "places" // necessary for places input
	}
});
/**
 *
 * @type {{domEvents: boolean, direction: number}}
 */
VueHammer.config.swipe = {
	direction: 6,
	domEvents: true
};
Vue.use(VueHammer);

/**
 * Youtube Component
 */
import VueYoutube  from 'vue-youtube';
Vue.use( VueYoutube  );

/**
 * Facebook SDK
 */
import vue_fb from '@/utils/FB_SDK';
Vue.use( vue_fb, {
	appId: 1366900477356758,
	autoLogAppEvents: true,
	xfbml: true,
	version: 'v18.0',
});

/**
 * Google Analytics
 */
import VueAnalytics from "vue-analytics";
Vue.use( VueAnalytics, {
	id: 'UA-42418531-3',
	router,
	autoTracking: {
	  page : true,
		// screenview: true
	},
    ignoreRoutes: ['/', '/login'],
	debug: {
		enabled : process.env.NODE_ENV !== 'production',
		sendHitTask: process.env.NODE_ENV === 'production'
	}
});

/**
 * Google Tag Manager
 */
// import VueGtm from '@gtm-support/vue2-gtm';
// Vue.use(VueGtm,{
//     id: 'GTM-TNFCBM7',
//     debug: true,
//     vueRouter: router,
//     ignoredViews: ['/','/login'],
//     trackOnNextTick: true
// });

/**
 * Firebase Messaging
 */
// import * as Push from '@/utils/firebase';

var swRegistration = null;
if ( 'serviceWorker' in navigator && window.location.protocol === 'https:' ) {
	window.addEventListener('load', async () => {
		swRegistration = await navigator.serviceWorker.register('/service-worker.js')
		         .then(registration => {
			         swRegistration = registration;
			         swRegistration.update();
			         if( typeof Vue.prototype.$messaging != 'undefined' ) {
				         Vue.prototype.$messaging.useServiceWorker(registration);
			         }
		         })
		         .catch(regError => {
			         console.warn(regError);
		         });
	});
}

Vue.config.productionTip = false;
// Global Event Bus
window.Events = new Vue();

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {App},
	template: '<App/>',
	directive: {},
});



// WEBPACK FOOTER //
// ./src/main.js